export const palacioMeta = [
  { label: 'Role', value: 'Senior UX Lead & Strategist (led 2 junior designers)' },
  { label: 'Industry', value: 'Luxury retail / Fintech' },
  { label: 'Timeline', value: '11 months · 2023' },
  { label: 'Main tools', value: 'Figma · Miro · GA4' },
];

export const palacioProblem = {
  lead: 'Shoppers bounced between a mobile-optimized site for retail and ',
  highlight: 'disconnected experiences in credit',
  tail: ' that only existed in person.',
};

export const palacioProcess = [
  {
    icon: 'flag',
    title: 'Kickoff session',
    body: 'Kicked off the project with key stakeholders, discussing their vision for the app, aligning on important milestones and defining KPIs.',
  },
  {
    icon: 'binoculars',
    title: 'In-store immersion',
    body: 'Immersed ourselves in the store experience via guided tours and self-guided tours of every floor.',
  },
  {
    icon: 'workshop',
    title: 'Stakeholder workshops',
    body: 'Led two, two-hour sessions in which we defined business requirements, clarified customer segments and immersed ourselves in the EPH brand.',
  },
  {
    icon: 'puzzle',
    title: 'Solution modeling sessions',
    body: 'Reviewed initial low-fidelity wireframes to stimulate stakeholder feedback around specific feature requirements.',
  },
  {
    icon: 'audit',
    title: 'Landscape audit',
    body: 'Audited the features and functionality of key competitor mobile experiences, best-in-class luxury brands and financial services apps.',
  },
] as const;

export const palacioDiscovery = [
  'Identified 4 key personas and mapped end-to-end “Experience Vision” journeys blending shopping and credit touch-points.',
  'Benchmarked against Liverpool, Chanel and Amex apps to set the luxury + fintech UX bar.',
];

export const palacioDelivery = [
  'Adopted an agile dual-workstream model (Commerce / Credit) with weekly design reviews to keep ~40 stakeholders in lock-step.',
  'Rapid, two-sprint loops: low-fi → annotated hi-fi wireframes → design skinning by junior designers, following the Palacio de Hierro design system.',
  'Set up a GA4 instrumentation plan before code freeze to track feature adoption from day 1.',
];

export const palacioDecisions = [
  {
    letter: 'A',
    title: 'A neutral home screen',
    body: 'The home screen gives marketing and credit each a clear, balanced zone. Neither side lost the space, which ended the turf war and let both teams ship.',
  },
  {
    letter: 'B',
    title: 'Navigation that changes with login',
    body: 'The bottom nav adapts to login state, so guests see shopping first and cardholders get their credit tools one tap away.',
  },
  {
    letter: 'C',
    title: 'Pivoting to white-label to hit the date',
    body: "A fully agnostic build wouldn't fit the timeline. We moved to a white-label approach and kept the launch date.",
  },
];

export const palacioStats = [
  { value: '11 months', label: 'from kickoff to App Store and Google Play, 1 month ahead of plan' },
  { value: '5-star', label: 'average on the Apple App Store; Top 10 iOS app in Mexico the week of release' },
  { value: '50K+', label: 'Google Play downloads in the launch window' },
  { value: '4.2-star', label: 'current rating for the app' },
];

export const palacioQuotes = [
  {
    quote:
      'It is a super intuitive platform, with a super functional and easy-to-use design. The clothing is easy to find and it also allows you to download the app from the United States. Love El Palacio!',
    source: 'App Store reviewer',
    note: 'Translated from Spanish',
  },
  {
    quote:
      'Kat was instrumental in providing clarity and direction to this complex project. Her ability to champion big-picture thinking without losing focus on the details made her an invaluable member of the team.',
    source: 'Customer Experience Director, Digital Transformation',
  },
];
